module.exports = __webpack_public_path__ + "static/media/getting-started.e02b2f89.jpg";